export const MAP_DEFAULTS = {
  CENTER: { lng: 108.0, lat: 15.5 } as const,
  ZOOM: 4.8,
  MIN_ZOOM: 0.5,
  MAX_ZOOM: 20,
  TERRAIN_EXAGGERATION: 2.0,
} as const;

export const VIETNAM_BOUNDS: [[number, number], [number, number]] = [
  [102.1, 8.2],
  [109.5, 23.4],
];

export const GEE_ALPHAEARTH_COLLECTION = 'GOOGLE/SATELLITE_EMBEDDING/V1/ANNUAL';
/**
 * Năm có thể chọn trên UI cho **ảnh Alpha Earth / tile GEE** (phạm vi vệ tinh đã biết).
 * Khác {@link GEE_SCENARIO_YEARS} — năm kịch bản lũ/ngập demo.
 */
export const GEE_ALPHAEARTH_UI_YEARS = [
  2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025,
] as const;
/** Năm có tile Alpha Earth đã xác minh từ backend/GEE (có thể chậm hơn lịch). */
export const GEE_ALPHAEARTH_KNOWN_AVAILABLE_YEARS = [
  2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025,
] as const;
export const GEE_ALPHAEARTH_YEARS = GEE_ALPHAEARTH_UI_YEARS;
/**
 * Năm ảnh vệ tinh “mới nhất” đã kiểm tra — dùng cho `isLive` / probe tile, **không** bắt buộc trùng năm kịch bản ngập.
 */
export const GEE_ALPHAEARTH_LATEST_KNOWN_AVAILABLE_YEAR = 2025;

const FALLBACK_SCENARIO_YEARS: readonly number[] = [2024, 2025];

function parseScenarioYearsFromEnv(raw: string | undefined): readonly number[] {
  if (raw == null || String(raw).trim() === '') return FALLBACK_SCENARIO_YEARS;
  const nums = String(raw)
    .split(',')
    .map((s) => Number.parseInt(s.trim(), 10))
    .filter((n) => Number.isFinite(n) && n >= 1990 && n <= 2100);
  const uniq = [...new Set(nums)].sort((a, b) => a - b);
  return uniq.length > 0 ? uniq : FALLBACK_SCENARIO_YEARS;
}

/**
 * Năm kịch bản lũ/ngập (chip năm dashboard, `geeParams.year` cho hiệu chỉnh vùng).
 * Override: `VITE_MAP_SCENARIO_YEARS` (vd. `2026` hoặc `2025,2026`).
 */
export const GEE_SCENARIO_YEARS = parseScenarioYearsFromEnv(
  import.meta.env.VITE_MAP_SCENARIO_YEARS as string | undefined,
);

/**
 * Năm mặc định cho kịch bản: ưu tiên năm dương lịch hiện tại nếu có trong {@link GEE_SCENARIO_YEARS}, không thì năm lớn nhất ≤ hiện tại, không thì phần tử cuối danh sách.
 */
export function getDefaultScenarioYear(): number {
  const cy = new Date().getFullYear();
  const ys = [...GEE_SCENARIO_YEARS];
  if (ys.includes(cy)) return cy;
  const notAfter = ys.filter((y) => y <= cy);
  if (notAfter.length > 0) return notAfter[notAfter.length - 1];
  return ys[ys.length - 1] ?? cy;
}

/** Giới hạn một năm vào danh sách scenario (gần nhất trong danh sách). */
export function clampScenarioYear(year: number): number {
  const ys = GEE_SCENARIO_YEARS;
  if (ys.length === 0) return year;
  let best = ys[0];
  let bestDist = Math.abs(year - best);
  for (const y of ys) {
    const d = Math.abs(year - y);
    if (d < bestDist || (d === bestDist && y > best)) {
      best = y;
      bestDist = d;
    }
  }
  return best;
}
